export const messages = {
  readAgain: 'Read Again',
  'revealTheTruth.text': `Press the button below to highlight the parts of this article that were generated using data this website has access to.`,
  'revealTheTruth.button': 'Reveal The Truth',
  'revealTheTruth.button.disabled':
    'Truth Has Been Revealed - Read the article again',

  'dataBlock.ip': 'IP Address',
  'dataBlock.city': 'City',
  'dataBlock.country': 'Country',
  'dataBlock.latAndLong': 'Latitude & Longtitue',
  'dataBlock.browserName': 'Browser Name',
  'dataBlock.browserVersion': 'Browser Version',
  'dataBlock.os': 'Operating System',
  'dataBlock.time': 'Your current time',
  'dataBlock.date': 'Your current date',
  'dataBlock.timezone': 'Your current timezone',
  'dataBlock.deviceOrientation': 'Device Orientation',
  'dataBlock.touchPosition': 'Touch Position',
  'dataBlock.mousePosition': 'Mouse Position',
  'dataBlock.referrer': 'Referrer',
  'dataBlock.searchParams': 'Search Parameters',
  'dataBlock.adBlocker': 'Ad Blocker',

  'condition.deviceType': 'Device Type',
  'condition.deviceType.description':
    'Based on some unique characteristics of your device (screen size, presence of certain sensors etc.), every website can guess what type of device it is.',
  'condition.deviceType.phone': 'Phone',
  'condition.deviceType.tablet': 'Tablet',
  'condition.deviceType.desktopOther': 'Desktop/Other',

  'condition.timeOfDay': 'Time Of Day',
  'condition.timeOfDay.morning': 'Morning',
  'condition.timeOfDay.noon': 'Noon',
  'condition.timeOfDay.evening': 'Evening',
  'condition.timeOfDay.night': 'Night',

  'condition.deviceOrientation': 'Device Orientation',
  'condition.deviceOrientation.still': 'Still',
  'condition.deviceOrientation.moving': 'Moving',
  'condition.deviceOrientation.unknown': 'Unknown',

  'condition.scrollingHand': 'Scrolling Hand',
  'condition.scrollingHand.noTouchScreen':
    "Your device doesn't seem to have a touch screen. It's therefore not possible to guess which hand you're using for scrolling.",
  'condition.scrollingHand.right': 'Right',
  'condition.scrollingHand.left': 'Left',
  'condition.scrollingHand.unknown': 'Unknown',
  'condition.scrollingHand.guesses.title': 'Guesses: L = left; R = right"',

  'condition.referrer': 'Referrer',
  'condition.referrer.description':
    'Any website can read what website you came from. Using UTM parameters that guess can be even more accurate.',
  'condition.referrer.pastKnownReferrers':
    'Past Known Referrers (where you came from)',
  'condition.referrer.other': 'Other/Unknown',

  'condition.pointer': 'Pointer',
  'condition.pointer.description':
    'In order to be able to be interactive, every website can listen to your mouse or touch movements.',
  'condition.pointer.mouse': 'Mouse',
  'condition.pointer.touch': 'Touch',
  'condition.pointer.unknown': 'Unknown',

  'condition.usesVPN': 'Uses VPN',
  'condition.usesVPN.description':
    "Whether you use VPN can be detected if there's a difference between geolocation of your IP address and the timezone your device is set in.",
  'condition.usesVPN.likely': 'Probably',
  'condition.usesVPN.unlikely': 'Unlikely',
  'condition.usesVPN.unknown': 'Unknown',

  'condition.searchParams': 'Search Parameters',
  'condition.searchParams.description':
    'The part of URL after a question mark can be used to target specific platforms or posts. In some cases, even specific individuals.',

  'condition.adBlocker': 'Ad Blocker',
  'condition.adBlocker.description':
    "Whether you use an ad blocker can be detected if there's a bait script that's known to be blocked by an ad blocking extension. That can be then used to detect a presence of the extension.",
  'condition.adBlocker.enabled': 'Enabled',
  'condition.adBlocker.disabled': 'Disabled',

  'condition.batteryChargingStatus': 'Battery Charging Status',
  'condition.batteryChargingStatus.charging': 'Charging',
  'condition.batteryChargingStatus.notCharging': 'Not charging',
  'condition.batteryChargingStatus.sdf': 'High',
  'condition.batteryChargingStatus.unknown': 'Unknown',

  'condition.batteryLevel': 'Battery Level',
  'condition.batteryLevel.low': 'Low',
  'condition.batteryLevel.average': 'Moderate',
  'condition.batteryLevel.high': 'High',
  'condition.batteryLevel.unknown': 'Unknown',

  'access.anyWebsite': 'Any website has access to this',
  'access.anyWebsiteGuess': 'Any website can guess this information',
  'access.anyWebsiteOrRequiresPermission': 'Your device may require permission',
};
